import { render, staticRenderFns } from "./FeatureManagement.vue?vue&type=template&id=c514eac6"
import script from "./FeatureManagement.vue?vue&type=script&lang=js"
export * from "./FeatureManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports